import { render, staticRenderFns } from "./PostsTable.vue?vue&type=template&id=1c2cb216&"
import script from "./PostsTable.vue?vue&type=script&lang=js&"
export * from "./PostsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports